import { LEADS_API } from "@/constants/content";

const DEFAULT_BASE = "https://propvision-backend-production.up.railway.app";
const DEFAULT_CLIENT_ID = "client_buildaxis_main";

function resolveLeadsBaseUrl() {
  const raw = (LEADS_API.baseUrl || DEFAULT_BASE).trim();
  if (/^https?:\/\//i.test(raw)) return raw.replace(/\/$/, "");
  return DEFAULT_BASE;
}

function buildWebsiteLeadBody(payload) {
  const clientId = (LEADS_API.clientId || DEFAULT_CLIENT_ID).trim() || DEFAULT_CLIENT_ID;
  const body = { client_id: clientId };

  const name = payload.name?.trim();
  const phone = payload.phone?.trim();
  const email = payload.email?.trim();
  const budget = payload.budget?.trim();
  const message = payload.message?.trim();

  if (name) body.name = name;
  if (phone) body.phone = phone;
  if (email) body.email = email;
  if (budget) body.budget = budget;
  if (message) body.message = message;

  return body;
}

export async function submitWebsiteLead(payload) {
  const url = `${resolveLeadsBaseUrl()}/leads/website`;
  const body = buildWebsiteLeadBody(payload);

  if (!body.phone && !body.email) {
    throw new Error("Please share your phone number or email.");
  }

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body),
    mode: "cors",
    credentials: "omit",
  });

  let data = null;
  const text = await res.text();
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = null;
    }
  }

  if (!res.ok) {
    const detail = data?.detail;
    const msg =
      typeof detail === "string"
        ? detail
        : Array.isArray(detail)
          ? detail.map((d) => d.msg || d).join(", ")
          : data?.message || (text && text.length < 200 ? text : null) || `Request failed (${res.status})`;
    throw new Error(msg);
  }

  return data;
}
